import PropTypes from "prop-types"
import { formatLabel } from "helpers/securities"

export default function Description(props) {
  const { id, description, name, ticker, isUnmodeled, assetClass } = props
  if (!id) { return null }

  let content
  if (assetClass === "swap" && !isUnmodeled) {
    return <>
      <div>{id}</div>
      <div className="break" />
      <div>{description}</div>
    </>
  } else if (isUnmodeled) {
    return <span className="description">{ticker ? formatLabel(props) : "Security"} is not modeled</span>
  } else if (description || name) {
    content = `${description ?? name}`
    if (ticker || id) {
      content = `${content} - ${ticker || id}`
    }
  } else {
    content = id
  }

  return <div className="description">
    {content}
  </div>
}

Description.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string,
  name: PropTypes.string,
  ticker: PropTypes.string,
  mic: PropTypes.string,
  isUnmodeled: PropTypes.bool,
  assetClass: PropTypes.string,
}
